<template>
  <div class="card border-radius-none">
    <div class="columns is-marginless is-paddingless is-multiline card-article">
      <div class="column is-12 is-paddingless">
        <div class="card-article-input-icon">
          &nbsp;
        </div>
        <div class="card-article-input-libelle-auto is-marginless">
          <b-field custom-class="is-size-7 is-marginless has-text-link"
                   :label="$t('detail.article.libelle')">
            <span >{{ ligneCommande.libelle }}
            </span>
          </b-field>
        </div>
        <div class="float-right mgt-25px mgr-20px">
          <a @click="openDetail = !openDetail" class="iconArrowMenu"
             :class="{'iconRecouvrementArrowMenuOpen': openDetail}">
            <b-icon
              icon="arrow-right-drop-circle"
              type="is-default"
            >
            </b-icon>
          </a>
        </div>
        <div class="has-text-weight-semibold mgt-30px float-right
          card-article-input-price-general right">
          <span v-if="ligneCommande.totalHt">
            {{ligneCommande.totalHt | formatDevise}}
          </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
      </div>
      <div class="column is-12 is-paddingless">
        <qd-collapse :open="openDetail" animation="slide-fade">
          <div class="card-article-personnalise">
            <div :key="ligne.ordre"
                          v-for="ligne in lignesCommande">
              <app-ligne-normale
                v-if="ligne.type === typeArticle
                      && ligne.referencePersonnalise === ligneCommande.referencePersonnalise"
                class="has-background-table-second-color"
                :societe-id="societeId"
                :sens="sens"
                :ligne-commande="ligne"
              />
              <app-ligne-produit-regroupement
                v-if="ligne.type === typeRegroupement
                      && ligne.referencePersonnalise === ligneCommande.referencePersonnalise"
                class="has-background-table-second-color"
                :sens="sens"
                :societe-id="societeId"
                :ligne-commande="ligne" />
            </div>
            <div class="card-article-bord-personnalisee">&nbsp;
            </div>
          </div>
        </qd-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';
import appLigneNormale from './ligneCommandeProduitNormal';
import appLigneProduitRegroupement from './ligneCommandeProduitRegroupement';

export default {
  name: 'ligneRegroupementPerso',
  props: {
    ligneCommande: Object,
    lignesCommande: Array,
    sens: {
      type: String,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  components: {
    appLigneNormale,
    appLigneProduitRegroupement,
  },
  data() {
    return {
      openDetail: true,
      typeArticle: devisConf.NORMAL,
      typeSousTotal: devisConf.SOUS_TOTAL,
      typePersonnalise: devisConf.PERSONNALISE,
      typeCommentaire: devisConf.COMMENTAIRE,
      typeRegroupement: devisConf.REGROUPEMENT,
      typeRemise: devisConf.REMISE,
    };
  },
  mounted() {
    const nombreLigneNormalSansProduit = this.lignesCommande.filter(l => l.type === this.typeArticle
      && l.referencePersonnalise === this.ligneCommande.referencePersonnalise
      && !l.produitId).length;
    let nombreLigneProduitAvecSousLigneSansProduit = 0;
    this.lignesCommande.filter(l => l.type === this.typeRegroupement
      && l.referencePersonnalise === this.ligneCommande.referencePersonnalise).forEach(l => {
      const nombreProduitVide = l.lignesCommande.filter(
        ligne => !ligne.produitId,
      ).length;
      nombreLigneProduitAvecSousLigneSansProduit += nombreProduitVide;
    });

    this.openDetail = nombreLigneNormalSansProduit > 0
      || nombreLigneProduitAvecSousLigneSansProduit > 0;
  },
  computed: {
  },
  methods: {

  },
};
</script>
